/**
 * Tertiary Header nav
 *
 * Includes a phone number and sign in link
 */
import { createComponent } from "react-fela";
import { ContentMaxWidth } from "~/components/layout/max-width";
import { colors, layout } from "~/styleguide";

import { useContext } from "react";
import { DataContext } from "~/context/content";
import get from "lodash.get";

export default function TertiaryNav({
    signInLink,
    signInLabel,
    phoneNumber,
    cta
}) {

    const pageData = useContext(DataContext);
    const type = get(pageData, "type");
    const slug = get(pageData, "slug");

    return (
        <ContentMaxWidth
            extend={{
                maxWidth: layout.mainNavWidth,
                textAlign: "right",
                paddingTop: 16,
                position: "relative",
                zIndex: 1,
                fontSize: 12,

                // Hidden on <= tablet
                maxWidthDesktop: { display: "none" }
            }}
        >
            <div>
                {/* Phone number */}
                {phoneNumber && (
                    <span className="ringdna-smartnumber">{phoneNumber}</span>
                )}

                {/* Sign In link */}
                {type !== "landingpages" && slug !== "construction" && signInLink && signInLabel && (
                    <SimpleLink href={signInLink}>{signInLabel}</SimpleLink>
                )}

                {type !== "landingpages" && slug !== "construction" && cta(tertCTAStyle)}
            </div>
        </ContentMaxWidth>
    );
}

const tertCTAStyle = {
    display: "none",
    marginLeft: 20,
};

const SimpleLink = createComponent(
    {
        color: colors.black,
        marginLeft: 20,
        whenActive: {
            color: colors.blue
        }
    },
    "a",
    ["className", "href"]
);
